/* eslint-disable */
import React, { useEffect, useContext, useState, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";

//import translation function for language translation
import { useTranslation } from "react-i18next";

// Import Editor here (both required).
// import { Editor } from "@tinymce/tinymce-react";
import JoditEditor from "jodit-react";

/*import url and gateway methods */
import {
  postData,
  putData,
  uploadMultipleFile,
  getData,
  uploadSingleFile,
} from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TaskStatusOptions from "data/Prod/TaskStatus.json";
import { assetImages } from "constants";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";
import { getCurrentTime } from "helper/TimeCalculation";

const SaveLogTimerModal = ({
  logId,
  workHours,
  taskStartTime = "",
  // taskDetailsObj = {},
  projectId,
  leadId,
  contactId,
  taskpercent,
  completedpercent,
  getTaskDetails = () => {},
}) => {
  const params = useParams();

  const { t } = useTranslation(); // translation

  const todayValue = new Date().toISOString().split("T")[0];

  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [taskStatusValue, settaskStatusValue] = useState(null);
  const [taskStatusData, settaskStatusData] = useState("");
  const [taskPercent, settaskPercent] = useState(0);
  const [logDetails, setlogDetails] = useState("");

  const [logAdding, setlogAdding] = useState(false);

  //* hook for validation */
  const [validation, setValidation] = useState({
    detailsWarning: false,
    statusWarning: false,
  });

  const editor = useRef(null);

  // const editorCustomConfig = joditEditorConfig(300);
  const editorCustomConfig = {
    readonly: false,
    placeholder: "",
    height: 300,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                ``;

              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setlogDetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  //* function to validate form */
  const validate = () => {
    let isValid = true;

    if (taskStatusData === null) {
      setValidation((prevState) => ({ ...prevState, userWarning: true }));
      isValid = false;
    }

    if (logDetails === "") {
      setValidation((prevState) => ({ ...prevState, detailsWarning: true }));
      isValid = false;
    }

    return isValid;
  };

  //* select status */
  const statusSelectionHandler = (val) => {
    settaskStatusValue(val);
    if (
      val.value === "0" ||
      val.value === "1" ||
      val.value === "2" ||
      val.value === "3"
    ) {
      settaskStatusData(val.value);
    }
  };

  //* reset */
  const resetLogFormHandler = () => {
    setlogDetails("");
  };

  //save log
  const saveLogHandler = async () => {
    if (validate()) {
      setlogAdding(true);

      try {
        let logData = {
          completedpercent: taskStatusData,
          description: logDetails,
          startdate: todayValue,
          enddate: todayValue,
          taskstarttime: taskStartTime,
          taskendtime: getCurrentTime(),
          hours: workHours,
          taskpercent: taskPercent,
          price: 0,
          uploads: [],
          lastworkingdate: todayValue,
        };

        let taskData = {
          endtime: getCurrentTime(),
          isworking: false,
          lastworkingdate: todayValue,
          logdata: logData,
        };

        let taskRequestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_TASK_TIMER +
          `/${params.id}`;

        let response = await putData(taskRequestUrl, taskData);

        // console.log("taskData", taskData);

        setlogAdding(false);

        console.log("response in save log timer modal", response);

        if (response.status) {
          resetLogFormHandler();
          getTaskDetails();
          // close the modal of addLabel
          const bootstarpModal = document.querySelector("#saveLogTimerModal");
          const modal = bootstrap.Modal.getInstance(bootstarpModal);
          modal.hide();
        }
      } catch (error) {}
    } else {
    }
  };

  useEffect(() => {
    if (taskpercent || completedpercent) {
      settaskPercent(taskpercent);

      const filteredStatus = TaskStatusOptions.filter((statusData) => {
        return statusData.value == completedpercent;
      });

      if (filteredStatus.length > 0) {
        statusSelectionHandler(filteredStatus[0]);
      } else {
        statusSelectionHandler(TaskStatusOptions[0]);
      }
    }
  }, [taskpercent, completedpercent]);

  return (
    <div
      className="modal fade"
      id="saveLogTimerModal"
      tabIndex="-1"
      aria-labelledby="saveLogTimerModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header p-4 pb-0 border-0">
            <h2 className="fw-bold mb-0" id="addLabelModalLabel">
              {t("Save Log")}
            </h2>
          </div>
          <div className="modal-body px-4 py-5">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group mb-3">
                <div className="row">
                  <div className="col-lg-4 mb-3 mb-lg-0">
                    <label
                      htmlFor=""
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Time (Hours)")}
                    </label>
                    <p className="form-control bg-white fs-sm shadow-none validation.hoursWarning border-gray-300">
                      {workHours}
                    </p>
                  </div>

                  <div className="col-lg-4 mb-3 mb-lg-0">
                    <label
                      htmlFor=""
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Complete %")}
                    </label>
                    <input
                      type="number"
                      className="form-control bg-white fs-sm shadow-none border-gray-300"
                      value={taskPercent}
                      onChange={(e) => {
                        if (e.target.value >= 0 && e.target.value <= 100) {
                          settaskPercent(e.target.value);
                        }
                      }}
                    />
                  </div>
                  <div className="col-lg-4 mb-3 mb-lg-0">
                    <label
                      htmlFor=""
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Task Status")}
                    </label>
                    <Select
                      placeholder="Select task status"
                      options={TaskStatusOptions}
                      value={taskStatusValue}
                      onChange={(val) => {
                        statusSelectionHandler(val);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group mb-3">
                <label htmlFor="" className="d-block fs-sm fw-semibold mb-2">
                  {t("Details")}
                </label>

                <JoditEditor
                  ref={editor}
                  value={logDetails}
                  config={editorConfig}
                  onBlur={(newContent) => {
                    // console.log("newContent", newContent);
                    setlogDetails(newContent);
                  }}
                  onChange={(newContent, event) => {
                    // setlogDetails(newContent);
                  }}
                />

                {validation.detailsWarning && (
                  <div className="error-message mt-2">
                    <p className="d-flex align-items-center gap-1 text-danger">
                      <span className="material-symbols-outlined">warning</span>
                      <span>{t("Please enter details!")}</span>
                    </p>
                  </div>
                )}
              </div>{" "}
            </form>

            <div className="action d-flex align-items-center gap-3">
              <button
                type="button"
                className="btn btn-primary ms-auto"
                onClick={saveLogHandler}
                disabled={logAdding ? true : false}
                style={{
                  cursor: logAdding ? "not-allowed" : "pointer",
                }}
              >
                {t("Save")}
                {logAdding && (
                  <div
                    className="mx-2 spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveLogTimerModal;
